$(document).on('click', '.podosinki-schema__element .podosinki-schema__element-bullet', function (e) {
    e.preventDefault();
    var $this = $(this),
        thisBlock = $this.siblings('.podosinki-schema__element-block');

    if ($this.parents('.podosinki-schema__element').hasClass('active')) {
        $this.parents('.podosinki-schema__element').removeClass('active');
        $this.siblings('.podosinki-schema__element-block').fadeToggle();
    } else {
        $('.podosinki-schema__element .podosinki-schema__element-block').fadeOut();
        $('.podosinki-schema__element').removeClass('active');
        $this.parents('.podosinki-schema__element').addClass('active');
        $this.siblings('.podosinki-schema__element-block').fadeIn();
    }

    // console.log(thisBlock.offset().left + thisBlock.width() > $(window).width());
    setTimeout(function () {
        if (thisBlock.offset().left + thisBlock.width() > $(window).width()) {
            thisBlock.css({
                'left': 'auto',
                'right': -10,
            });
        } else if (thisBlock.offset().left < -10) {
            thisBlock.css({
                'left': -10,
                'right': 'auto',
            });
        } else {
            thisBlock.removeAttr('style');
        }
    }, 50)



    $('.himki-schema__left-inform-list h5').text('Участок №' + $this.text());
    $('.modal-ekskurs h4 span').text($this.text());
    $('.modal-ekskurs .area-num').val($this.text());

});

$(document).mouseup(function (e) { // событие клика по веб-документу
    var div = $('.podosinki-schema__element .podosinki-schema__element-block, .podosinki-schema__element .podosinki-schema__element-bullet'); // тут указываем ID элемента
    if (!div.is(e.target) // если клик был не по нашему блоку
        &&
        div.has(e.target).length === 0) { // и не по его дочерним элементам
        $('.podosinki-schema__element').removeClass('active');
        $('.podosinki-schema__element .podosinki-schema__element-block').fadeOut();
    }
});

$('.podosinki-schema__element-block a').on('click', function (e) {
    e.preventDefault();
    openModal('modal-ekskurs');

    var areaNum = $(this).parents('.podosinki-schema__element-block').siblings('.podosinki-schema__element-bullet').text();
    $('.modal-ekskurs h4 span').text(areaNum);
    $('.modal-ekskurs .area-num').val(areaNum);
});


$('.invest-btn ').on('click', function (e) {
    e.preventDefault();
    openModal('modal-structure');
});

$('.element-btn').on('click', function (e) {
    e.preventDefault();
    openModal('modal-ekskurs');
})